/** Ignore stale async poll responses when a newer request has started. */
export function shouldAcceptPollResult(requestSeq: number, latestSeq: number): boolean {
  return requestSeq === latestSeq;
}
